import { createContext, type JSX, useContext } from 'solid-js'
import { MainModule } from '../../../features/main-module'
import { type GetDashboardInteractor } from '../../../features/dashboard/domain/interactors/get-dashboard.interactor'

interface DashboardContextType {
  getDashboard: GetDashboardInteractor
}

const CorisDashboardContext = createContext<DashboardContextType>()

export const CorisDashboardProvider = (props: { children: JSX.Element }): JSX.Element => {
  const dashboardComponent = MainModule.getDashboardComponent()

  const defaultContextValue: DashboardContextType = {
    getDashboard: dashboardComponent.provideGetDashboard()
  }

  return <CorisDashboardContext.Provider value={defaultContextValue}>{props.children}</CorisDashboardContext.Provider>
}

export const useCorisDashboard = (): DashboardContextType => {
  const context = useContext(CorisDashboardContext)
  if (!context) {
    throw new Error('useCorisDashboard must be used inside a CorisDashboardProvider')
  }
  return context
}
